var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade-slide"}},[(_vm.visible)?_c('button',{staticClass:"back-to-top",attrs:{"aria-label":"回到顶部"},on:{"click":_vm.scrollToTop}},[_c('i',{staticClass:"el-icon-top"})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }